import { BasicAuthServiceHelper } from '@/modules/Auth'
import { AnimalProfile } from '@/dataV3/Animal/AnimalProfile'
import { GetAnimalProfile, GetMemberProfile, GetPublicProfile, GetSimilarPublicProfiles, GetUserCard } from './apiTypes'
import { MemberProfile } from '@/dataV3/User/MemberProfile'
import { PublicProfile } from '@/data'
import { IRI } from 'emt-library'
import { UserCard } from '@/dataV3/Search/UserCard'

export const getAnimalProfile = async (animalId: string): Promise<AnimalProfile> => {
  return await BasicAuthServiceHelper.requestAuthenticatedV2Async<
    GetAnimalProfile.Response,
    never,
    GetAnimalProfile.UrlParams
  >(GetAnimalProfile.Route, {
    urlPathParams: { animalId },
  })
}

export const getMemberProfile = async (memberId: string): Promise<MemberProfile> => {
  return await BasicAuthServiceHelper.requestAuthenticatedV2Async<
    GetMemberProfile.Response,
    never,
    GetMemberProfile.UrlParams
  >(GetMemberProfile.Route, {
    urlPathParams: { memberId },
  })
}

export const getUserCard = async (profileId: string): Promise<UserCard> => {
  return await BasicAuthServiceHelper.requestAuthenticatedV2Async<GetUserCard.Response, never, GetUserCard.UrlParams>(
    GetUserCard.Route,
    {
      urlPathParams: { profileId },
    },
  )
}

export const getPublicProfile = async (profileId: string): Promise<PublicProfile> => {
  return await BasicAuthServiceHelper.requestAuthenticatedV2Async<
    GetPublicProfile.Response,
    never,
    GetPublicProfile.UrlParams
  >(
    GetPublicProfile.Route,
    {
      urlPathParams: { profileId },
    },
    { doNotAuthenticate: true },
  )
}

export const getSimilarPublicProfiles = async (similarIRI: IRI): Promise<PublicProfile[]> => {
  const result = await BasicAuthServiceHelper.requestAuthenticatedV2Async<GetSimilarPublicProfiles.Response>(
    GetSimilarPublicProfiles.Route(similarIRI),
  )

  return result?.['hydra:member'] || []
}
